import Price from '~/utils/Price';

import ComparativePrice from './ComparativePrice';
import mapComparativePriceProduct, { RawComparativePriceProduct } from './mapComparativePriceProduct';

export interface RawComparativePrice {
	value: string;
	currency: string;
	fromProducts: RawComparativePriceProduct[];
}

export default function mapComparativePrice(comparativePrice: RawComparativePrice): ComparativePrice {
	return new ComparativePrice(
		new Price(comparativePrice.value, comparativePrice.currency),
		comparativePrice.fromProducts.map(mapComparativePriceProduct)
	);
}
